import React, {useState} from 'react';
import {Field, withFormik} from "formik";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import {connect} from "react-redux";
import MaterialTextField from "../../../comun/Forms/MaterialTextField";
import {Grid} from "../../../comun/Grid/Grid";


export let CityFilters = ({city, handleSubmit, manage=false, ...props}) => {
    
    return(
        <React.Fragment>
            <form className="form-filters" onSubmit={handleSubmit}>
                <h3>Filtros</h3>
                <Grid columns="1fr 1fr" mobileColumns="1fr">
                    <Field className="form-filters-text" size="small" component={MaterialTextField} name="name"
                           variant="outlined" label="Nombre" />
                    
                    <Field className="form-filters-text" size="small" component={MaterialTextField} name="locality"
                           variant="outlined" label="Localidad" />

                    <Field className="form-filters-text" size="small" component={MaterialTextField} name="province"
                           variant="outlined" label="Provincia" />

                    <Button  variant="contained" className="form-control-child-input-height" color="secondary" type="submit">Filtrar</Button>
                </Grid>

            </form>
        </React.Fragment>
    )
}

const schema = Yup.object().shape({
    name: Yup.string(),
    locality: Yup.string(),
    province: Yup.string(),
});

CityFilters = withFormik(
    {
        validationSchema: schema,
        mapPropsToValues: (props) => {
            return {
                name: '',locality: '', province: ''
            }
        },
        handleSubmit: async (vals, props) => {
            const data = Object.assign({}, vals);
            props.setSubmitting(false);
            props.props.onSubmit(data);
        },
        displayName: 'Filtrar Ciudades',
    }
)(CityFilters);
const mapPropsToState = state => {
    return {
        city: state.city
    }
}

CityFilters = connect(mapPropsToState, null)(CityFilters);
